import {
  API_URL,
  store
} from '../index'
import axios from 'axios/index'

/* import error handler */
import ErrorHandler from '../ErrorHandler'
import SuccessHandler from '../SuccessHandler'

/* private Customer Types */
import {
  Settings,
  _CustomerBranchOffice
} from '../namespace-helper'

import _ from 'lodash'

const selectedCustomerBranchOfficeTemplate = {
  id: 0,
  name: '',
  taxnumber: null,
  street: null,
  hnumber: null,
  city: null,
  zipcode: null,
  contry: null,
  customers_id: null,
  terms_of_deliveries_id: null,
  terms_of_payments_id: null
}

export default {
  namespaced: true,
  state: {
    customerBranchOffices: [],
    selectedBranchOffice: _.cloneDeep(selectedCustomerBranchOfficeTemplate)
  },
  mutations: {
    [_CustomerBranchOffice.mutations.addNewBranchOffice] (state, payload) {
      if (state.customerBranchOffices === null) {
        state.customerBranchOffices = []
      }
      state.customerBranchOffices.push(payload)
    },
    [_CustomerBranchOffice.mutations.removeBranchOffice] (state, payload) {
      state.customerBranchOffices.splice(payload, 1)
    },
    [_CustomerBranchOffice.mutations.setBranchOffices] (state, payload) {
      state.customerBranchOffices = payload
    },
    [_CustomerBranchOffice.mutations.setSelectedBranchOffice] (state, payload) {
      if (payload !== null) {
        state.selectedBranchOffice = payload
      } else {
        state.selectedBranchOffice = _.cloneDeep(selectedCustomerBranchOfficeTemplate)
      }
    }
  },
  actions: {
    [_CustomerBranchOffice.actions.addNewBranchOffice] ({ commit }, payload) {
      commit(_CustomerBranchOffice.mutations.addNewBranchOffice, payload)
    },
    [_CustomerBranchOffice.actions.setSelectedBranchOffice] ({ commit }, payload) {
      commit(_CustomerBranchOffice.mutations.setSelectedBranchOffice, payload)
    },
    [_CustomerBranchOffice.actions.removeBranchOffice] (context, payload) {
      var tempBranchOffices = context.getters.getCustomerBranchOffices
      var id = tempBranchOffices[payload].id

      if (id === 0) {
        context.commit(_CustomerBranchOffice.mutations.removeBranchOffice, payload)
        return
      }

      var url = API_URL + '/api/v1/customerBranchOffices/' + id

      console.log('removeBranchOffice: ' + id)

      store.commit(Settings.mutations.setLoading, true)

      axios.delete(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        ErrorHandler.clear(store)
        context.commit(_CustomerBranchOffice.mutations.removeBranchOffice, payload)
        SuccessHandler.handleApiSuccess(store, r.data.message)
        store.commit(Settings.mutations.setLoading, false)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
        store.commit(Settings.mutations.setLoading, false)
      }).catch(e => console.error('#### ' + e))
    },
    [_CustomerBranchOffice.actions.saveBranchOffices] (context, payload) {
      store.commit(Settings.mutations.setLoading, true)

      payload.forEach(function (v, i, o) {
        const data = JSON.stringify(v)

        if (v.id === 0) {
          var url = API_URL + '/api/v1/customerBranchOffices'

          axios.post(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            store.commit(Settings.mutations.setLoading, false)
            ErrorHandler.clear(store)
            SuccessHandler.handleApiSuccess(store, r.data.message)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
          }).catch(e => console.error('#### ' + e))
        } else {
          url = API_URL + '/api/v1/customerBranchOffices/' + v.id

          axios.put(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            store.commit(Settings.mutations.setLoading, false)
            ErrorHandler.clear(store)
            SuccessHandler.handleApiSuccess(store, r.data.message)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
          }).catch(e => console.error('#### ' + e))
        }
      })
    },
    [_CustomerBranchOffice.actions.loadCustomerBranchOffices] (context, payload) {
      var url = API_URL + '/api/v1/customerBranchOffices/customer/' + payload

      console.log('loadCustomerBranchOffices: ' + payload)

      store.commit(Settings.mutations.setLoading, true)

      axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        ErrorHandler.clear(store)
        context.commit(_CustomerBranchOffice.mutations.setBranchOffices, r.data.data)
        console.log('loadCustomerBranchOffices: ' + JSON.stringify(r.data))
        store.commit(Settings.mutations.setLoading, false)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
        store.commit(Settings.mutations.setLoading, false)
      }).catch(e => console.error('#### ' + e))
    },
    [_CustomerBranchOffice.actions.resetCustomerBranchOffices] ({ commit }, payload) {
      commit(_CustomerBranchOffice.mutations.setBranchOffices, [])
    },
    [_CustomerBranchOffice.actions.resetState] ({ commit }, payload) {
      commit(_CustomerBranchOffice.mutations.setBranchOffices, [])
      commit(_CustomerBranchOffice.mutations.setSelectedBranchOffice, null)
    }
  },
  getters: {
    [_CustomerBranchOffice.getters.getCustomerBranchOffices] (state) {
      return state.customerBranchOffices
    },
    [_CustomerBranchOffice.getters.getSelectedBranchOffice] (state) {
      return state.selectedBranchOffice
    }

  }
}



// WEBPACK FOOTER //
// ./src/store/Customer/customerBranchOffices.js